import { Helmet } from "react-helmet-async";
import {
  BRAND_KEYWORDS,
  DEFAULT_OG_IMAGE,
  OFFICE_GEO,
  SEO_DEFAULTS,
  absoluteUrl,
} from "@/lib/seoConfig";

export default function SeoHead({
  title = SEO_DEFAULTS.title,
  description = SEO_DEFAULTS.description,
  keywords,
  canonical,
  ogImage = DEFAULT_OG_IMAGE,
  ogType = "website",
  noindex = false,
  jsonLd,
}) {
  const canonicalUrl = canonical || absoluteUrl("/");
  const keywordStr = keywords || SEO_DEFAULTS.keywords;
  const gscToken = process.env.REACT_APP_GSC_VERIFICATION;
  const jsonLdBlocks = Array.isArray(jsonLd) ? jsonLd.filter(Boolean) : jsonLd ? [jsonLd] : [];

  return (
    <Helmet prioritizeSeoTags>
      <html lang="en-IN" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywordStr} />
      <meta name="author" content="OORI Label" />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large"} />
      <link rel="canonical" href={canonicalUrl} />
      <link rel="alternate" type="text/plain" href="https://oorilabel.com/llms.txt" title="llms.txt" />

      <meta name="geo.region" content={OFFICE_GEO.region} />
      <meta name="geo.placename" content={OFFICE_GEO.placename} />
      <meta name="geo.position" content={`${OFFICE_GEO.latitude};${OFFICE_GEO.longitude}`} />
      <meta name="ICBM" content={`${OFFICE_GEO.latitude}, ${OFFICE_GEO.longitude}`} />

      {gscToken ? <meta name="google-site-verification" content={gscToken} /> : null}

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content="OORI Label" />
      <meta property="og:locale" content="en_IN" />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:secure_url" content={ogImage} />
      <meta property="og:image:alt" content="OORI Label" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      <meta name="application-name" content="OORI Label" />
      <meta name="apple-mobile-web-app-title" content="OORI Label" />
      <meta name="brand" content={BRAND_KEYWORDS.slice(0, 6).join(", ")} />

      {jsonLdBlocks.map((block, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(block)}
        </script>
      ))}
    </Helmet>
  );
}
